import React, { ReactNode } from 'react'
import { StyleSheet, View } from 'react-native'
import { DS } from '@/design-system'

type SectionProps = {
  title: string
  /** Draws a divider line above the title to separate it from the previous section */
  showDivider?: boolean
  children: ReactNode
}

/** Home section: optional divider, "Heading 3" title and a vertical stack of cards. */
function Section({ title, showDivider = false, children }: SectionProps) {
  return (
    <View style={styles.section}>
      <View style={[styles.header, showDivider && styles.headerWithDivider]}>
        {showDivider && <View style={styles.divider} />}
        <DS.Text variant="Heading 3/Medium">{title}</DS.Text>
      </View>
      {children}
    </View>
  )
}

const styles = StyleSheet.create({
  section: {
    gap: DS.spacing[12]
  },
  header: {
    gap: DS.spacing[12]
  },
  headerWithDivider: {
    paddingTop: DS.spacing[12]
  },
  divider: {
    height: 1,
    backgroundColor: DS.palette['Brand/Light Grey']
  }
})

export default Section
